import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CardTitle, NavLink } from "reactstrap";

const CoinBoxBlog = ({ heroTitle, content, link }: any) => {
  const { t } = useTranslation();

  return (
    <div>
      <CardTitle className="fs-7 text-secondary-two-light text-end">
        {heroTitle}
      </CardTitle>
      <p className="fs-6 text-secondary-two-light text-end">{content}</p>
      <div className="d-flex flex-lg-row flex-sm-row-reverse justify-content-between fs-6">
        <div className="d-flex  flex-lg-row flex-sm-row-reverse align-items-center">
          <i className="icon-schedule text-end ps-2" />
          <span className="text-end">
            {t("{{number}}Days ago", { number: "۲" })}
          </span>
        </div>
        <div className="d-flex  flex-lg-row flex-sm-row-reverse justify-content-between align-items-center">
          <NavLink href={link} className="text-warning-light ps-2 ">
            {t("Read more")}
          </NavLink>
          <i className="icon-arrow-circle-left" />
        </div>
      </div>
    </div>
  );
};
export default CoinBoxBlog;
